import { lazy } from 'react';

const ForecastingDashboard = lazy(() =>
  import('../pages/ForecastingDashboard/index.js').then((module) => ({
    default: module.ForecastingDashboard,
  })),
);

const forecastingDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'forcasting_dashboard',
      path: '/finance-and-account/forecast-dashboard',
      component: ForecastingDashboard,
    },
  ],
};

export default forecastingDashboardRoute;
